import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Box , LinearProgress ,Tooltip, IconButton,   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, } from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import Viewer from 'react-viewer';
import { useHistory } from "react-router-dom";
import Modal from '../Generales/ModalInformativo';
import moment from 'moment';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {toast} from "react-toastify";
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {        
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },     
    },
     container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
      },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
  }));

const ModalNotificacion = ({modalAbierto,setModalAbierto,titulo,lista, setLista, contadorBadge, setContadorBadge  }) => {
  let history = useHistory();
  const classes = useStyles();
  const idusu= localStorage.getItem('UsuId');  
  const [cargando, setCargando] = useState(false);
  const [espera,setEspera]= useState(false);
  const [mensaje, setMensaje] = useState('');
  const [aviso, setAviso] = useState(false);
  const [registro, setRegistro] = useState([]);
  const [verImg, setVerImg] = useState(false)
  const [listImg, setListImg] = useState([])    
      const Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs'   

  //const[lista,setLista]= useState([])                                                                   
  const source = axios.CancelToken.source();      
  React.useEffect(()=>{    
   
    return ()=> {
      source.cancel();
    }     
      
  },[]);
 
    
   const getListaUpdate = (auxId,auxStatus) => {  
    const data = qs.stringify({   
        Usuario:idusu,//usuario.usrId,    
        Llave:auxId,
        Tipo:"ISREAD",
        Status:auxStatus===1 ? 0 :1,     
        idDispositivo: auxDispV,
    });
    const url = "/notificacion/update";
    function respuesta(aux) {
      if (aux) 
      { 
  
        const mensaje="Se actualizo correctamente el estatus de lectura. "
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        let nvoArr= []
        lista.forEach(element => {          
          if (element.Id === auxId) {
            nvoArr.push({...element, IsRead:auxStatus===1 ? 0 :1 })
          }
          else{
            nvoArr.push(element)
          }
        });
        //console.log(nvoArr);
        if (contadorBadge >0) {
          setContadorBadge(contadorBadge-1)  
        }
        
        setLista(nvoArr)
      }    
    }
    llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setCargando,history,source);
  };    
  

  const cerrarBorrar = () => {        
    setAviso(false);
    setModalAbierto(false)
  };

  const celda = (alinear, estilo, contenido) => {
    return (
    <TableCell
      align={alinear} className={classes.tableCell}
      padding={"none"} style={estilo}
    >
      {contenido}
    </TableCell>
    );
  }; 

  const abrirImg=( row)=>{   
    setVerImg(true)
    const cadena=row.Img+"|"
    let nvoCad="",  bandera=false, nvoArr=[]
    for (let index = 0; index < cadena.length; index++) {
      const element = cadena.charAt(index)
      
      if (element==="|" && !bandera) {
        nvoArr.push({Img:nvoCad})
        nvoCad=""
      }else{
        nvoCad+=element
      }
      }
    setListImg(nvoArr)    
  }   

   function Row(props) {
    const {row} = props;
    const auxColor= registro?.Id=== row.Id ? "white":process.env.REACT_APP_COLOR_SEC
    return (
    <TableRow onClick={() => { setRegistro( row); }}
      className={classes.tableRow} selected={registro?.Id === row.Id}
      classes={{hover: classes.hover, selected: classes.selected}}
    >   
      {celda("center",{fontWeight:700,width:30+'px'}, 
        row.IsRead === 0 ?          
          <Tooltip title={'Actualizar a leída.'}>
            <IconButton color={auxColor==="white"?"inherit":"primary"}  aria-label="add circle" size={"small"}
              component="span" onClick={()=>getListaUpdate(row.Id, row.IsRead)} style={{justifyContent:"center"}}
            >
              <CheckCircleOutlineIcon/>  
            </IconButton>             
            </Tooltip>                                                                                                                 
      : <Tooltip title={'Actualizar a No leída.'}>
            <IconButton color={auxColor==="white"?"inherit":"primary"}  aria-label="add circle" size={"small"}
              component="span" onClick={()=>getListaUpdate(row.Id, row.IsRead)} style={{justifyContent:"center"}}
            >
              <CheckCircleIcon/>  
            </IconButton>             
          </Tooltip>                 )}        
      {celda("center",{fontWeight:700,width:30+'px'}, 
        row.Img.length !== 0 ?          
          <Tooltip title={'Ver Foto'}>
            <IconButton color={auxColor==="white"?"inherit":"primary"}  aria-label="add circle" size={"small"}
              component="span" onClick={()=>abrirImg(row)} style={{justifyContent:"center"}}
            >
              <PhotoLibraryIcon/>  
            </IconButton>             
            </Tooltip>                                                                                                                 
        :<TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 120+ 'px', fontSize:"13px"}}>
          
      </TableCell>)}  
        
     {/*  <TableCell className={classes.tableCell} align="center" padding={'none'}
        style={{fontWeight: 700, width: 40 + 'px'}}>
        {row.AgeId}
      </TableCell> */}
      <TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 120+ 'px', fontSize:"13px"}}>
          {moment.utc(row.Fch).local(true).format("DD/MM/YYYY hh:mm")}
      </TableCell>
      <TableCell className={classes.tableCell} align="left" padding={'none'} 
        style={{fontSize: "13px",   }}>
          { row.Alias }
      </TableCell> 
        <TableCell className={classes.tableCell} align="left" padding={'none'} 
        style={{fontSize: "13px", paddingLeft:"5px" }}>
          { row.Descr }
      </TableCell>      
    </TableRow>    
    );
    }
  
  function tablaCompleta(auxlista) {
    return (
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>                      
          <TableCell align="center" padding='none'>{}</TableCell>
{/*           <TableCell align="center" padding='none'>{}</TableCell> */}
          <TableCell align="center" padding='none'>{auxlista.length}</TableCell>
          <TableCell align="center" padding='none'>Fecha </TableCell>
          <TableCell align="center" padding='none'>Descripción</TableCell>                      
          <TableCell align="center" padding='none'>Notas</TableCell>   
        </TableRow>
      </TableHead>
      <TableBody>
          {auxlista.length !== 0 ? (auxlista.map((row) => (
              <Row key={row.Id} row={row}/>
          ))) 
          :
          <TableRow>
            <TableCell align="center" padding='none'>{}</TableCell>
          <TableCell align="center" padding='none'>Sin</TableCell>
          <TableCell align="center" padding='none'></TableCell>
          <TableCell align="center" padding='none'>Registros </TableCell>
          <TableCell align="center" padding='none'></TableCell>                      
          </TableRow>
          
          }
      </TableBody>
    </Table>
    </TableContainer>
    )
  }

    return ( 
    <Modal
      titulo={titulo} modalAbierto={modalAbierto}
      setModalAbierto={setModalAbierto} maxTam={false}
      tamanio={"md"} cerrarBorrar={cerrarBorrar}
    >
    <form  noValidate autoComplete="off" fullWidth>       
      <Box  display="flex" flexDirection="column" className={classes.root} style={{overflowY:"true", }}>  
        { !cargando ? tablaCompleta(lista) : <Box width={"40rem"}> <LinearProgress/></Box>}
        <Viewer zIndex={2000}
            visible={verImg} onClose={() => setVerImg(false) }
            images={listImg.map((imagen, index) => {
                return ({src: imagen.Img, alt: ''})
            })}      
            
          />
        {/*  lista.length!==0?
          lista.map((registro)=>{
            const fecha = moment.utc(registro.Fecha);  
            const modificada= fecha.local(true).format("DD/MM/YYYY HH:mm");  
          return(   
          <Card style={{width:30+'rem',height:"2rem",alignContent:"center"}}>
            <Box display="flex" flexDirection={"row"} style={{marginLeft:".5rem" ,alignItems:"center"}}>
              <Typography component="p" variant="body2" style={{color:"#51ad32",fontWeight:"700"}}>
                {registro.Id}
              </Typography>
              <Typography component="p" variant="body2" style={{marginLeft:".5rem", marginRight:".5rem",fontSize:"12px" }} >
                {modificada}
              </Typography>
            <Typography id="outlinedTecnico"           
              component="p" variant="body2"  style={{color:"#51ad32",fontSize:"12px",fontWeight:"700" }}                                               
            >    
            { `  ${registro.Nota}`}
            </Typography>
  
            </Box>
          </Card>                               
          )
          })
          :<Card><Typography> Sin Notificaciones</Typography></Card> */}
      </Box>
    </form>
    </Modal>
    );
}
 
export default ModalNotificacion;